/* ==========================================================================
   TØTE — Cold-traffic landing page interactions
   Kopstorm CommV
   - Bundle picker: swatch select + AJAX add-to-cart + open theme cart drawer
   - Falls back to a built-in preview drawer when no theme drawer is present
   - Tabs / markers / day-steps / FAQ / testimonial carousel / countdown / copy
   ========================================================================== */
(function () {
  'use strict';

  if (window.__kvClpBooted) return;   // guard: safe when loaded by multiple sections
  window.__kvClpBooted = true;

  var money = function (cents) {
    if (window.theme && window.theme.moneyFormat) {
      // very small money formatter for the {{amount}} pattern
      var amount = (cents / 100).toFixed(2);
      return window.theme.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }
    return '\u20ac' + (cents / 100).toFixed(2);
  };

  /* ----------------------------------------------------------------------
     BUNDLE PICKER
     ---------------------------------------------------------------------- */
  function initBundle(root) {
    var cards = root.querySelectorAll('[data-clp-card]');
    cards.forEach(function (card) {
      // swatch selection updates the variant id + media
      card.querySelectorAll('[data-clp-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          card.querySelectorAll('[data-clp-swatch]').forEach(function (s) {
            s.classList.remove('kv-clp-swatch--active');
            s.setAttribute('aria-pressed', 'false');
          });
          sw.classList.add('kv-clp-swatch--active');
          sw.setAttribute('aria-pressed', 'true');
          if (sw.dataset.variant) card.dataset.variant = sw.dataset.variant;
          var img = card.querySelector('[data-clp-media-img]');
          if (img && sw.dataset.image) img.src = sw.dataset.image;
        });
      });

      var addBtn = card.querySelector('[data-clp-add]');
      var quickBtn = card.querySelector('[data-clp-quick]');
      var submit = function () { addToCart(card, addBtn); };
      if (addBtn) addBtn.addEventListener('click', submit);
      if (quickBtn) quickBtn.addEventListener('click', submit);
    });
  }

  function addToCart(card, btn) {
    var variantId = card.dataset.variant;
    if (!variantId) return;

    if (btn) { btn.classList.remove('is-done'); btn.classList.add('is-loading'); }

    var themeDrawer = document.querySelector('cart-drawer');

    // Real Shopify theme path -------------------------------------------
    if (themeDrawer && window.routes && window.routes.cart_add_url && typeof fetchConfig === 'function') {
      var sections = themeDrawer.getSectionsToRender().map(function (s) { return s.id; });
      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', 1);
      fd.append('sections', sections);
      fd.append('sections_url', window.location.pathname);
      config.body = fd;

      fetch(window.routes.cart_add_url, config)
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { failBtn(btn); return; }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kv-clp-bundle', productVariantId: variantId });
          }
          themeDrawer.classList.remove('is-empty');
          themeDrawer.renderContents(res); // re-renders drawer contents AND opens it
          doneBtn(btn);
        })
        .catch(function () { failBtn(btn); });
      return;
    }

    // Preview / no-theme-drawer path (built-in drawer) -------------------
    setTimeout(function () {
      previewAdd(card);
      doneBtn(btn);
    }, 450);
  }

  function doneBtn(btn) {
    if (!btn) return;
    btn.classList.remove('is-loading');
    btn.classList.add('is-done');
    var label = btn.querySelector('[data-clp-add-label]') || btn;
    var prev = label.textContent;
    label.textContent = 'Added \u2713';
    setTimeout(function () { btn.classList.remove('is-done'); label.textContent = prev; }, 1600);
  }
  function failBtn(btn) {
    if (!btn) return;
    btn.classList.remove('is-loading');
    var label = btn.querySelector('[data-clp-add-label]') || btn;
    label.textContent = 'Unavailable';
  }

  /* ----------------------------------------------------------------------
     PREVIEW CART DRAWER (only used when theme drawer is absent)
     ---------------------------------------------------------------------- */
  var previewItems = [];
  function previewAdd(card) {
    var drawer = document.querySelector('[data-clp-drawer]');
    if (!drawer) return;
    var title = card.dataset.title || 'TØTE Bag';
    var color = (card.querySelector('.kv-clp-swatch--active') || {}).dataset;
    var colorName = color && color.color ? color.color : '';
    var price = parseInt(card.dataset.price || '0', 10);
    var img = (card.querySelector('[data-clp-media-img]') || {}).src || '';

    var existing = previewItems.filter(function (i) { return i.title === title && i.color === colorName; })[0];
    if (existing) { existing.qty += 1; }
    else { previewItems.push({ title: title, color: colorName, price: price, img: img, qty: 1 }); }
    renderPreviewDrawer(drawer);
    openPreviewDrawer(drawer);
  }
  function renderPreviewDrawer(drawer) {
    var body = drawer.querySelector('[data-clp-drawer-body]');
    var count = previewItems.reduce(function (n, i) { return n + i.qty; }, 0);
    var total = previewItems.reduce(function (n, i) { return n + i.price * i.qty; }, 0);
    drawer.querySelector('[data-clp-drawer-count]').textContent = count;
    drawer.querySelector('[data-clp-drawer-total]').textContent = money(total);
    body.innerHTML = previewItems.map(function (i) {
      return '<div class="kv-clp-drawer__item">' +
        '<div class="kv-clp-drawer__thumb"><img src="' + i.img + '" alt=""></div>' +
        '<div class="kv-clp-drawer__meta"><strong>' + i.title + '</strong>' +
        (i.color ? '<span>' + i.color + '</span>' : '') +
        '<div><b>' + money(i.price) + '</b> &times; ' + i.qty + '</div></div></div>';
    }).join('');
  }
  function openPreviewDrawer(drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closePreviewDrawer(drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  function initPreviewDrawer() {
    var drawer = document.querySelector('[data-clp-drawer]');
    if (!drawer) return;
    drawer.querySelector('[data-clp-drawer-close]').addEventListener('click', function () { closePreviewDrawer(drawer); });
    drawer.querySelector('[data-clp-drawer-overlay]').addEventListener('click', function () { closePreviewDrawer(drawer); });
  }

  /* ----------------------------------------------------------------------
     TABS
     ---------------------------------------------------------------------- */
  function initTabs(root) {
    var btns = root.querySelectorAll('[data-clp-tab]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
        btn.setAttribute('aria-selected', 'true');
        root.querySelectorAll('[data-clp-tab-panel]').forEach(function (p) { p.removeAttribute('data-active'); });
        var panel = root.querySelector('[data-clp-tab-panel="' + btn.dataset.clpTab + '"]');
        if (panel) panel.setAttribute('data-active', '');
      });
    });
  }

  /* ----------------------------------------------------------------------
     INTERACTIVE MARKERS
     ---------------------------------------------------------------------- */
  function initMarkers(root) {
    var markers = root.querySelectorAll('[data-clp-marker]');
    markers.forEach(function (m) {
      m.addEventListener('click', function (e) {
        e.stopPropagation();
        var pop = root.querySelector('[data-clp-marker-pop="' + m.dataset.clpMarker + '"]');
        var open = m.getAttribute('aria-expanded') === 'true';
        markers.forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
        root.querySelectorAll('[data-clp-marker-pop]').forEach(function (p) { p.removeAttribute('data-open'); });
        if (!open) { m.setAttribute('aria-expanded', 'true'); if (pop) pop.setAttribute('data-open', ''); }
      });
    });
    document.addEventListener('click', function () {
      markers.forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
      root.querySelectorAll('[data-clp-marker-pop]').forEach(function (p) { p.removeAttribute('data-open'); });
    });
  }

  /* ----------------------------------------------------------------------
     DAY STEPS (hover/click highlight)
     ---------------------------------------------------------------------- */
  function initDaySteps(root) {
    var steps = root.querySelectorAll('[data-clp-step]');
    steps.forEach(function (s) {
      s.addEventListener('mouseenter', function () {
        steps.forEach(function (x) { x.classList.remove('kv-clp-day__step--active'); });
        s.classList.add('kv-clp-day__step--active');
      });
    });
  }

  /* ----------------------------------------------------------------------
     FAQ (filters + accordion)
     ---------------------------------------------------------------------- */
  function initFaq(root) {
    root.querySelectorAll('[data-clp-faq-q]').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('[data-clp-faq-item]');
        var a = item.querySelector('[data-clp-faq-a]');
        var open = item.hasAttribute('data-open');
        if (open) { item.removeAttribute('data-open'); a.style.maxHeight = null; }
        else { item.setAttribute('data-open', ''); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
    var filters = root.querySelectorAll('[data-clp-faq-filter]');
    filters.forEach(function (f) {
      f.addEventListener('click', function () {
        filters.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        f.setAttribute('aria-pressed', 'true');
        var cat = f.dataset.clpFaqFilter;
        root.querySelectorAll('[data-clp-faq-item]').forEach(function (item) {
          var show = cat === 'all' || item.dataset.cat === cat;
          item.style.display = show ? '' : 'none';
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     TESTIMONIAL CAROUSEL
     ---------------------------------------------------------------------- */
  function initQuotes(root) {
    var slides = root.querySelectorAll('[data-clp-quote]');
    var dots = root.querySelectorAll('[data-clp-quote-dot]');
    var idx = 0;
    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.toggleAttribute('data-active', i === idx); });
      dots.forEach(function (d, i) { d.toggleAttribute('data-active', i === idx); });
    }
    var prev = root.querySelector('[data-clp-quote-prev]');
    var next = root.querySelector('[data-clp-quote-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    go(0);
  }

  /* ----------------------------------------------------------------------
     WELCOME CODE + COUNTDOWN
     ---------------------------------------------------------------------- */
  function initWelcome(root) {
    var form = root.querySelector('[data-clp-welcome-form], form.kv-clp-welcome__form');
    var reveal = root.querySelector('[data-clp-welcome-code]');
    if (form && reveal) {
      reveal.style.display = 'none';
      form.querySelector('[data-clp-welcome-btn]').addEventListener('click', function (e) {
        e.preventDefault();
        var input = form.querySelector('input');
        if (input && input.checkValidity && !input.checkValidity()) { input.reportValidity(); return; }
        reveal.style.display = '';
      });
    }
    var copyBtn = root.querySelector('[data-clp-welcome-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var code = root.querySelector('[data-clp-welcome-value]').textContent.trim();
      if (navigator.clipboard) navigator.clipboard.writeText(code);
      var t = copyBtn.textContent; copyBtn.textContent = 'COPIED'; setTimeout(function () { copyBtn.textContent = t; }, 1400);
    });
    // countdown to end of day
    var hEl = root.querySelector('[data-clp-cd-h]');
    var mEl = root.querySelector('[data-clp-cd-m]');
    var sEl = root.querySelector('[data-clp-cd-s]');
    if (hEl && mEl && sEl) {
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var tick = function () {
        var now = new Date();
        var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        var diff = Math.max(0, Math.floor((end - now) / 1000));
        hEl.textContent = pad(Math.floor(diff / 3600));
        mEl.textContent = pad(Math.floor((diff % 3600) / 60));
        sEl.textContent = pad(diff % 60);
      };
      tick(); setInterval(tick, 1000);
    }
  }

  /* ----------------------------------------------------------------------
     GENERIC COPY BUTTONS + MOBILE NAV
     ---------------------------------------------------------------------- */
  function initMisc() {
    var burger = document.querySelector('[data-clp-burger]');
    var nav = document.querySelector('[data-clp-mobilenav]');
    if (burger && nav) burger.addEventListener('click', function () { nav.classList.toggle('is-open'); });
  }

  function initScrollButtons() {
    document.querySelectorAll('[data-clp-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var key = btn.getAttribute('data-clp-scroll');
        var target = document.querySelector('[data-clp-anchor="' + key + '"]');
        if (!target && key === 'bundle') target = document.querySelector('[data-clp-shop-anchor]');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initInsta() {
    document.querySelectorAll('[data-clp-insta-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grid = btn.closest('.kv-clp__wrap').querySelector('[data-clp-insta-grid]');
        if (grid) grid.classList.add('is-expanded');
        btn.style.display = 'none';
      });
    });
  }

  function initReveal() {
    var sections = [].slice.call(document.querySelectorAll('.kv-clp__section'));
    if (!sections.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      sections.forEach(function (el) { el.classList.add('kv-clp-reveal', 'kv-clp-in'); });
      return;
    }

    sections.forEach(function (el) { el.classList.add('kv-clp-reveal'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('kv-clp-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    sections.forEach(function (el) { io.observe(el); });
  }

  /* ----------------------------------------------------------------------
     BOOT
     ---------------------------------------------------------------------- */
  function boot() {
    document.querySelectorAll('[data-clp-bundle]').forEach(initBundle);
    document.querySelectorAll('[data-clp-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-clp-markers]').forEach(initMarkers);
    document.querySelectorAll('[data-clp-daysteps]').forEach(initDaySteps);
    document.querySelectorAll('[data-clp-faq]').forEach(initFaq);
    document.querySelectorAll('[data-clp-quotes]').forEach(initQuotes);
    document.querySelectorAll('[data-clp-welcome]').forEach(initWelcome);
    initPreviewDrawer();
    initMisc();
    initInsta();
    initScrollButtons();
    initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();